import React, { memo } from 'react';
import { Breadcrumb, BreadcrumbGroup } from '@amzn/storm-ui';
import { LinkBreadcrumb } from './LinkBreadcrumb';
import { TextBreadcrumb } from './TextBreadcrumb';
import type { Breadcrumb as BreadcrumbType } from '../../../../app/slice';

const BreadcrumbListWithReference: React.VFC<{
  handleRef?: (e: HTMLElement, index: number) => void;
  totalBreadcrumbs: Array<BreadcrumbType>;
}> = ({ handleRef, totalBreadcrumbs }) => (
  <BreadcrumbGroup>
    {totalBreadcrumbs.map((breadcrumb, index) => {
      if (breadcrumb.url) {
        return (
          <span
            key={`${breadcrumb.label ?? ''}-${index}`}
            ref={(e) => {
              if (e && handleRef) {
                handleRef(e as HTMLElement, index);
              }
            }}
          >
            <Breadcrumb>
              <LinkBreadcrumb breadcrumb={breadcrumb} />
            </Breadcrumb>
          </span>
        );
      }
      return (
        <Breadcrumb key={`${breadcrumb.label ?? ''}-${index}`}>
          <span
            ref={(e) => {
              if (e && handleRef) {
                handleRef(e as HTMLElement, index);
              }
            }}
          >
            <TextBreadcrumb breadcrumb={breadcrumb} />
          </span>
        </Breadcrumb>
      );
    })}
  </BreadcrumbGroup>
);

export const BreadcrumbListWithRef = memo(BreadcrumbListWithReference);
